 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import TEXT9781684351855_COVER from '@/components/text/9781684351855_Cover'
 import TEXT9781684351855_FRONTMATTER from '@/components/text/9781684351855_Frontmatter'
 import TEXT9781684351855_HALFTITLE from '@/components/text/9781684351855_Halftitle'
 import TEXT9781684351855_FRONTMATTER01 from '@/components/text/9781684351855_Frontmatter01'
 import LOVE_1 from '@/components/love_1'
 import TEXT9781684351855_TITLE from '@/components/text/9781684351855_Title'
 import TEXT9781684351855_COPYRIGHT from '@/components/text/9781684351855_Copyright'
 import TEXT9781684351855_DEDICATION from '@/components/text/9781684351855_Dedication'
 import TEXT9781684351855_CONTENTS from '@/components/text/9781684351855_Contents'
 import TEXT9781684351855_FOREWORD from '@/components/text/9781684351855_Foreword'
 import TEXT9781684351855_PROLOGUE from '@/components/text/9781684351855_Prologue'
 import TEXT9781684351855_CHAPTER_1A from '@/components/text/9781684351855_Chapter_1a'
 import TEXT9781684351855_CHAPTER_1 from '@/components/text/9781684351855_Chapter_1'
 import TEXT9781684351855_CHAPTER_2 from '@/components/text/9781684351855_Chapter_2'
 import TEXT9781684351855_CHAPTER_3 from '@/components/text/9781684351855_Chapter_3'
 import TEXT9781684351855_CHAPTER_4 from '@/components/text/9781684351855_Chapter_4'
 import TEXT9781684351855_CHAPTER_5 from '@/components/text/9781684351855_Chapter_5'
 import TEXT9781684351855_CHAPTER_6 from '@/components/text/9781684351855_Chapter_6'
 import TEXT9781684351855_CHAPTER_7 from '@/components/text/9781684351855_Chapter_7'
 import TEXT9781684351855_CHAPTER_8 from '@/components/text/9781684351855_Chapter_8'
 import TEXT9781684351855_CHAPTER_9 from '@/components/text/9781684351855_Chapter_9'
 import TEXT9781684351855_CHAPTER_10 from '@/components/text/9781684351855_Chapter_10'
 import TEXT9781684351855_CHAPTER_11 from '@/components/text/9781684351855_Chapter_11'
 import TEXT9781684351855_CHAPTER_12 from '@/components/text/9781684351855_Chapter_12'
 import TEXT9781684351855_CHAPTER_13 from '@/components/text/9781684351855_Chapter_13'
 import LOVE_2 from '@/components/love_2'
 import TEXT9781684351855_ACKNOWLEDGMENTS_AND_CREDITS from '@/components/text/9781684351855_Acknowledgments_and_Credits'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/text/9781684351855_Contents",
 			"name" : "text/9781684351855_Contents",
 			"component" : TEXT9781684351855_CONTENTS
 		},
 		{
 			"path" : "/text/9781684351855_Foreword",
 			"name" : "text/9781684351855_Foreword",
 			"component" : TEXT9781684351855_FOREWORD
 		},
 		{
 			"path" : "/text/9781684351855_Prologue",
 			"name" : "text/9781684351855_Prologue",
 			"component" : TEXT9781684351855_PROLOGUE
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js